import { useTranslation } from 'react-i18next'
import useLightModePreference from '../util/useLightModePreference'
import { SAVE_BACKGROUND } from './translation/resources'
import './SaveBackgroundButton.css'

const SaveBackgroundButton = ({ setIsHover, handleSaveVirtualBackground }) => {
  const { t } = useTranslation()
  const isLightMode = useLightModePreference()

  const handleSaveBackground = (e) => {
    setIsHover(false)
    handleSaveVirtualBackground()
  }

  return (
    <button
      className={`SaveBackgroundButton ${!isLightMode ? 'dark-mode' : ''}`}
      onClick={handleSaveBackground}
    >
      <p className="SaveBackgroundButton-text">{t(SAVE_BACKGROUND)}</p>
    </button>
  )
}

export default SaveBackgroundButton
